import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import Config from 'organization/Event/Configurable/Config'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import React, {useState} from 'react'

export default function RulesConfig() {
  const {waiver} = useTemplate()
  const saveTemplate = useSaveTemplate()

  const [rules, setRules] = useState(waiver.skipRules)

  const save = () => {
    saveTemplate({
      waiver: {
        skipRules: rules,
      },
    })
  }

  return (
    <Config title="Skip Waiver" onSave={save}>
      <RulesPanel
        rules={rules}
        setRules={setRules}
        configProps={{
          description: 'Waiver will be skipped when',
        }}
      />
    </Config>
  )
}
